import { UnknownAction, configureStore } from '@reduxjs/toolkit';
import { ThunkDispatch, thunk } from 'redux-thunk';
import { Dispatch } from 'react';
 
import rootReducer from './redux/reducer';

const store = configureStore({
    reducer: rootReducer,
    duplicateMiddlewareCheck: false,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }).concat(thunk),
});

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = Dispatch<UnknownAction> & ThunkDispatch<RootState, null, UnknownAction>

export default store;
